import './index.css'
import 'react-toastify/dist/ReactToastify.css'
import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import Lobby from './pages/(lobby)/page'
import DemoCreateMeeting from '@/pages/DemoCreateMeeting'
import './index.css'
import GlobalWrapper from '@/contexts/GlobalWrapper'
import Hall from '@/pages/Hall'
import SignIn from '@/pages/sign-in'
import { ErrorPage } from './pages/Error'
import CreateDebate from './pages/create-debate/page'
import LearningToolkit from '@/pages/learning-toolkit/page'
import DebateElementsCourse from '@/pages/learning-toolkit/debate-elements-course/page'
import SpeechToolkit from '@/pages/learning-toolkit/speech-toolkit/page'
import { TermsAndConditions } from './pages/TermsAndConditions'
import './global.sass'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { PaddleCheckout } from './pages/PaddleCheckout'
import UIWrapper from './contexts/UIWrapper'

const App = () => {
  // Mobile 100vh fix: keep a real viewport height in a CSS var.
  useEffect(() => {
    const setVh = () => {
      const h = window.visualViewport?.height ?? window.innerHeight
      document.documentElement.style.setProperty('--vh', `${h * 0.01}px`)
    }
    setVh()
    window.addEventListener('resize', setVh)
    window.visualViewport?.addEventListener?.('resize', setVh)
    return () => {
      window.removeEventListener('resize', setVh)
      window.visualViewport?.removeEventListener?.('resize', setVh)
    }
  }, [])

  return (
    <div className="bg-background dark:text-white noScrollbar min-h-[calc(var(--vh)*100)] flex flex-col">
      <GlobalWrapper>
        <UIWrapper>
          <Routes>
            <Route path="/" element={<Lobby />} />
            <Route path="/hall/:id" element={<Hall />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/create-debate" element={<CreateDebate />} />
            <Route path="/learning-toolkit" element={<LearningToolkit />} />
            <Route
              path="/learning-toolkit/debate-elements-course"
              element={<DebateElementsCourse />}
            />
            <Route path="/learning-toolkit/speech-toolkit" element={<SpeechToolkit />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/paddle-checkout" element={<PaddleCheckout />} />
            {/* For Example only */}
            <Route path="/demoCreateMeeting" element={<DemoCreateMeeting />} />
          </Routes>
        </UIWrapper>
      </GlobalWrapper>
    </div>
  )
}
export default App
